<template>

  <select-input
    :label="label"
    v-model="formData"
    value-key="value"
    label-value="label"
    :placeholder="placeholder"
    :size="size"
    :list="selectData"
    :required="required"
    :disabled="disabled"
    :no-form="noForm"
    @change="updated"
  />

</template>

<script>

export default {
  name: 'select-approval-status',

  props: {
    label: {
      type: String,
      default: 'Approval Status'
    },
    value: {
      //      type: String,
      required: true
    },
    prop: {
      type: String,
      default: this.label
    },
    size: {
      type: String,
      default: 'normal'
    },
    disabled: {
      type: Boolean,
      default: false
    },
    required: {
      type: Boolean,
      default: false
    },
    placeholder: {
      type: String,
      default: null
    },
    helpText: {
      type: String,
      default: null
    },
    noForm: {
      type: Boolean,
      default: false
    }
  },


  methods: {
    updated (value) {
      this.$emit('input', value)
      this.$emit('change', value)
    }
  },

  data () {
    return {
      formData: this.value,
      selectData: this.getConfig().selects.approvalStatus
    }
  }
}
</script>



// WEBPACK FOOTER //
// SelectApprovalStatus.vue?7a2bd041